"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_POPUP_HEIGHT_PX = exports.DEFAULT_POPUP_WIDTH_PX = exports.FRACTAL_DOMAIN_HTTPS_WWW = exports.FRACTAL_DOMAIN_HTTPS = exports.FRACTAL_DOMAIN = void 0;
exports.FRACTAL_DOMAIN = 'fractal.is';
exports.FRACTAL_DOMAIN_HTTPS = 'https://fractal.is';
exports.FRACTAL_DOMAIN_HTTPS_WWW = 'https://www.fractal.is';
exports.DEFAULT_POPUP_WIDTH_PX = 400;
exports.DEFAULT_POPUP_HEIGHT_PX = 600;
//# sourceMappingURL=constants.js.map